import { parseAsDateUTC } from 'app/infrastructure/data/date';
import { ExternalUrlResults } from './types';
import { ExternalUrlListItem } from 'app/area/external-urls-administration/list/types-store';

export const mapList = (listWire: ExternalUrlResults[]): ExternalUrlListItem[] => {

  if ((listWire?.length ?? 0) === 0) {
    return [];
  }

  return listWire.map(item => ({
    id: item?.code?.v,
    description: item?.code?.d,
    ...(item?.code?.disabled && { disabled: parseAsDateUTC(item?.code?.disabled) }),
    ...(item?.urlTemplate && { urlTemplate: item?.urlTemplate })
  }));
};
